import { render } from "./LabelingOverview.vue?vue&type=template&id=6e00a0fc&ts=true"
import script from "./LabelingOverview.vue?vue&type=script&lang=ts"
export * from "./LabelingOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__